import { Box, Link, Stack, Typography } from '@mui/material'

import { company } from '@/lib/company'

/**
 * Who is behind this, on every page a stranger can reach.
 *
 * The pay page is the one that needs it most. Somebody arrives from an email
 * saying they owe forty dollars to a service they have never heard of, and
 * until this line existed the page never said who was asking. That is a trust
 * problem before it is a compliance one — but it is both.
 *
 * Quiet by construction: caption type, secondary colour, below the fold of the
 * card it follows. Nothing here should compete with the amount or the button.
 */
export function Footer({ dense = false }: { dense?: boolean }) {
  return (
    <Box
      component="footer"
      sx={{
        mt: dense ? 3 : 4,
        pt: 2,
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        justifyContent="center"
        flexWrap="wrap"
        sx={{ rowGap: 0.5 }}
      >
        <Link
          href="/privacy"
          variant="caption"
          underline="hover"
          sx={{ color: 'text.secondary' }}
        >
          Privacy
        </Link>
        <Link
          href="/terms"
          variant="caption"
          underline="hover"
          sx={{ color: 'text.secondary' }}
        >
          Terms
        </Link>
        <Link
          href={`mailto:${company.email}`}
          variant="caption"
          underline="hover"
          sx={{ color: 'text.secondary' }}
        >
          Contact
        </Link>
      </Stack>

      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 1, color: 'text.secondary' }}
      >
        Fronted is operated by {company.name}
        {company.postalAddress && `, ${company.postalAddress}`}.
      </Typography>

      {/* Said on the public pages because it is the thing people most often
        * get wrong about us, and getting it wrong is what makes somebody
        * hesitate to click. We are not in the payment path at all. */}
      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}
      >
        We never handle your money — you pay the person directly.
      </Typography>
    </Box>
  )
}
